import axios from 'axios';

const getJpmErrorCodes = async () => {
  const { data } = await axios.get<Record<string, string>>(
    'supra/jpm_error_codes',
  );

  return data;
};

export default getJpmErrorCodes;
